import { ScanInStoreEarnAndRedeemCardWithoutSubscription } from './ScanInStoreEarnAndRedeemCardWithoutSubscription';
import { ScanInStoreEarnAndRedeemCardWithSubscription } from './ScanInStoreEarnAndRedeemCardWithSubscription';

export const ScanInStoreEarnAndRedeemCard = {
  WithSubscription: ScanInStoreEarnAndRedeemCardWithSubscription,
  WithoutSubscription: ScanInStoreEarnAndRedeemCardWithoutSubscription,
} as const;
